import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/registrationDatesServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Registrationdates = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({ id: '', conetitle: '', conedate: '', ctwotitle: '', ctwodate: '', cthreetitle: '', cthreedate: ''});

  // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true); 
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]); // Assuming there's only one record to edit
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


const validateForm = () => {
    const newErrors = {};
    if (!form.conetitle) newErrors.conetitle = "Early Bird On/Before Title  is required";  
    if (!form.conedate) newErrors.conedate = "Date   is required";  
    if (!form.ctwotitle) newErrors.ctwotitle = "Mid-Term Title is required";  
    if (!form.ctwodate) newErrors.ctwodate = "Date is required";  
    if (!form.cthreetitle) newErrors.cthreetitle = "Final_call Title is required";  
    if (!form.cthreedate) newErrors.cthreedate = "Date is required"; 
     
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

  // Handle input change
  const handleChange = (e) => {
    try{
    const { name, value } = e.target;
    let updatedErrors = { ...errors };
    setForm((prev) => ({ ...prev, [name]: value }));
     if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
      setErrors(updatedErrors);
    }
    catch (error) {
      console.error('Error in handleChange:', error);
    } 
  };

  // Handle form submission (update details)
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (!validateForm()) {
          return
        }
      let result; 
      result = await updateData(form);
      if(result.status === 200|201){
        fetchData();  // Re-fetch data after adding/editing
        toast.success("Saved successfully!", {position: 'top-right',});
      }
      else{
        toast.error(result?.message ||"Failed to update data. Please try again.", {position: 'top-right'});
      }
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Basic Setup & File upload / Registration Setup <b>/ Registration Dates</b></p>
              {/* <h2 className='mb-3'>Past Webinar / Webinar Videos</h2> */}
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
        {/* <h2 className='mb-3'>Registration Setup / Registration Dates</h2> */}
          <Form onSubmit={handleSubmit}>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Early Bird On/Before Title <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="conetitle"
                value={form.conetitle}
                onChange={handleChange}
                isInvalid={!!errors.conetitle}
              />
              <Form.Control.Feedback type="invalid">{errors.conetitle}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Date <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="date"
                name="conedate"
                value={form.conedate}
                onChange={handleChange}
                 isInvalid={!!errors.conedate}
              />
              <Form.Control.Feedback type="invalid">{errors.conedate}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Mid-Term Title <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="ctwotitle"
                value={form.ctwotitle}
                onChange={handleChange}
                 isInvalid={!!errors.ctwotitle}
              />
              <Form.Control.Feedback type="invalid">{errors.ctwotitle}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Date <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="date"
                name="ctwodate"
                value={form.ctwodate}
                onChange={handleChange}
                 isInvalid={!!errors.ctwodate}
              />
              <Form.Control.Feedback type="invalid">{errors.ctwodate}</Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Final_call Title <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="cthreetitle"
                value={form.cthreetitle}
                onChange={handleChange}
                isInvalid={!!errors.cthreetitle}
              />
              <Form.Control.Feedback type="invalid">{errors.cthreetitle}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Date <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="date"
                name="cthreedate"
                value={form.cthreedate}
                onChange={handleChange}
                isInvalid={!!errors.cthreedate}
              />
              <Form.Control.Feedback type="invalid">{errors.cthreedate}</Form.Control.Feedback>
            </Form.Group>
            </div>

            <Button variant="success" type='submit'>Submit</Button>          
          </Form>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Registrationdates;
